export default __webpack_public_path__ + "static/media/img-press-release-ovato-will-be.f901a08d.jpg";